module.exports = __webpack_public_path__ + "img/Arrow2.751ece93.svg";